import { i18n } from "@lingui/core";
import { WIcon } from "@warp-ds/components/react/icon";
import { Button, Modal } from "@warp-ds/react";
import { Box } from "@warp-ds/react/components/box";
import { useState } from "react";

export interface SortingInfoProps {
	className?: string;
}
export function SortingInfo({ className }: SortingInfoProps) {
	const [open, setOpen] = useState(false);

	return (
		<div className={className}>
			<Button
				link
				className="inline-flex items-center gap-x-4 text-caption"
				onClick={() => setOpen(true)}
				aria-haspopup="dialog"
				aria-expanded={open}
			>
				{i18n.t({ id: "explore.sorting.info.trigger", message: "Find out how it works" })}
				<WIcon name="Info" size="small" locale={i18n.locale} aria-hidden="true" />
			</Button>
			<Modal
				open={open}
				right
				onDismiss={() => setOpen(false)}
				title={<span className="t3">{i18n.t({ id: "explore.sorting.title", message: "How Explore works" })}</span>}
			>
				<div>
					<h2 className="t4">
						{i18n.t({ id: "explore.sorting.info.title-one", message: "Search results based on intent" })}
					</h2>
					<p className="text-body mb-16">
						{i18n.t({
							id: "explore.sorting.info.body-one",
							message:
								"Explore uses AI to understand what you're looking for. Unlike traditional search on recommerce, which only shows results including your exact search term, Explore looks beyond keywords to find listings that match your intent.",
						})}
					</p>
					<Box info className="mb-16 px-24 py-16">
						<p className="s-text">
							<Button type="button" quiet link className="s-text-link" href="?q=Vintage+kitchen+items">
								{i18n.t({ id: "explore.sorting.info.try-it", message: "Try it!" })}
							</Button>{" "}
							{i18n.t({
								id: "explore.sorting.info.body-try-it-one-rest",
								message:
									"Type “Vintage kitchen items”, and Explore will suggest relevant listings like vintage tableware, lamps, and decorations.",
							})}
						</p>
					</Box>
					<h2 className="t4">
						{i18n.t({ id: "explore.sorting.info.title-two", message: "Explore analyses text and images" })}
					</h2>
					<p className="text-body mb-16">
						{i18n.t({
							id: "explore.sorting.info.body-try-it-two",
							message:
								"Explore analyses all the information in a listing, including images, when searching for results. The traditional search on recommerce only scans the text on listings.",
						})}
					</p>
					<Box info className="mb-16 px-24 py-16">
						<p className="s-text">
							<Button type="button" quiet link className="s-text-link" href="?q=Outfit+for+an+office+summer+party">
								{i18n.t({ id: "explore.sorting.info.try-it", message: "Try it!" })}
							</Button>{" "}
							{i18n.t({
								id: "explore.sorting.info.body-try-it-two-rest",
								message:
									"Search for “Outfit for an office summer party”, and Explore will suggest clothing suited for the occasion.",
							})}
						</p>
					</Box>
				</div>
			</Modal>
		</div>
	);
}
